module.exports = __webpack_public_path__ + "img/end01.7621f14a.png";